"use strict";

module.exports = require("../../fine-uploader/fine-uploader.core");



//////////////////
// WEBPACK FOOTER
// ./~/fine-uploader/lib/core/index.js
// module id = 960
// module chunks = 0